import React, { useState } from 'react';
import styled from 'styled-components';
import { TextField, InputAdornment, IconButton } from '@mic3/platform-ui';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const MaskedTextField = styled(TextField)`
  & input {
    -webkit-text-security: ${(props) => (props.$isMasked ? 'disc' : 'none')};
    -moz-text-security: ${(props) => (props.$isMasked ? 'disc' : 'none')};
  }
`;

export default function PasswordTextField(props) {
    const [isMasked, setIsMasked] = useState(true);

    const handleToggleMask = () => {
        setIsMasked(!isMasked);
    };

    return (
        <form autoComplete="off">
            <input
                type="text"
                name="hidden"
                autoComplete="new-password"
                style={{ display: 'none' }}
            />

            <MaskedTextField
                {...props}
                $isMasked={isMasked}
                autoComplete="off"
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleToggleMask} edge="end">
                                {isMasked ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
            />
        </form>
    );
}
